<!-- Header footer section start -->
<section id="header-footer">
    <div class="row">
        <div class="col-12 mb-1">
            <div class="content-header" [innerHTML]="collection?.title | highlightText: searchTerm"></div>
            <p class="content-sub-header mb-1" [innerHtml]="collection?.description | highlightText: searchTerm"></p>
        </div>
    </div>
    <div class="row">
        <div class="col-11">
            <span class="badge badge-pill badge-primary mb-1 mr-2" *ngFor='let t of collection?.rb_tags'
                (click)='selectTag(t)'>{{t.name}}</span>
        </div>
        <div class="col-1"> <span class="badge badge-pill badge-primary mb-1 mr-2" (click)="back()">Back</span></div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_1'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_1 | highlightText: searchTerm | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_1)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_2'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_2 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_2)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_3'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_3 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_3)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_4'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_4 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_4)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_5'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_5 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_5)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_6'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_6 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_6)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_7'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_7 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_7)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_8'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_8 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_8)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="row match-height" *ngIf='collection?.content_9'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection?.content_9 | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection.content_9)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Header footer section end -->

<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Verify Password</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="mb-3">
                <label for="dateOfBirth">Enter Password</label>
                <div class="input-group">
                    <input class="form-control" placeholder="password" type="password" name="dp" [(ngModel)]='password' (keyup.enter)="detail()">
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)='detail()'>Save</button>
    </div>
</ng-template>
<!--Modal with Default options ends-->